import {
  GET_CATEGORY_FINANCE,
  GET_CATEGORY_FINANCE_ORGANIZED,
  CREATE_CATEGORY_FINANCE,
  DELETE_CATEGORY_FINANCE,
  UPDATE_CATEGORY_FINANCE,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  GET_CATEGORIES_FINANCE_SELECT,
} from './actionType';

// common success
export const CategoryFinanceApiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const CategoryFinanceApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const CategoryFinance = () => ({
  type: GET_CATEGORY_FINANCE,
});

export const GetCategoryFinanceOrganized = (type) => ({
  type: GET_CATEGORY_FINANCE_ORGANIZED,
  payload: { type },
});

export const CreateCategoryFinance = (data, history) => ({
  type: CREATE_CATEGORY_FINANCE,
  payload: { data, history },
});

export const GetCategoriesFinanceSelect = (type) => ({
  type: GET_CATEGORIES_FINANCE_SELECT,
  payload: { type },
});

export const UpdateCategoryFinance = (data, history) => ({
  type: UPDATE_CATEGORY_FINANCE,
  payload: { data, history },
});

export const DeleteCategoryFinance = (id) => ({
  type: DELETE_CATEGORY_FINANCE,
  payload: { id },
});
